import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'

// JobRequests
import MaintenanceRequest from "@/views/JobRequests/MaintenanceRequest"
import MaintenanceHistory from "@/views/JobRequests/MaintenanceHistory"
import NewOrder from '@/views/JobRequests/MaintenanceRequest/NewOrder'
import Details from '@/views/JobRequests/MaintenanceRequest/Details'
import NonMaintenanceRequest from "@/views/JobRequests/NonMaintenanceRequest"
import NonMaintenanceDetails from '@/views/JobRequests/NonMaintenanceRequest/Detail'
import AddNonMaintenanceRequest from '@/views/JobRequests/NonMaintenanceRequest/Add'
import NonMaintenanceHistory from "@/views/JobRequests/NonMaintenanceHistory"
import NonMaintenancHistoryeDetails from '@/views/JobRequests/NonMaintenanceHistory/Detail'
import MonthlyWorker from "@/views/JobRequests/MonthlyWorker"
import VendorClock from "@/views/JobRequests/VendorClock"
import VendorClockAdd from '@/views/JobRequests/VendorClock/Add'
import MajorProject from "@/views/JobRequests/Contractor"
import MajorProjectEdit from "@/views/JobRequests/Contractor/Edit"
import MaintenaceReport from '@/views/JobRequests/MaintenaceReport/index.js'
import  MonthlyWorkerPayment from '@/views/JobRequests/MonthlyWorkePayment'
import MaterialList from '@/views/JobRequests/MaterialList'
import Map from '@/components/Map'
import PUTTable from '@/views/JobRequests/MaintenanceRequest/component/PUTTable'
import PUTTableHistory from '@/views/JobRequests/MaintenanceHistory/component/PUTTableHistory'

const jobRequests = [
  {
    path: "/JobRequests",
    element: <SandBox />,
    children: [
      {
        path: "Maintenance",
        element: docLazyFn(<MaintenanceRequest />),
      },
      {
        path: "MaintenanceHistory",
        element: docLazyFn(<MaintenanceHistory />),
      },
      {
        path: "NonMaintenanceRequest",
        element: docLazyFn(<NonMaintenanceRequest />),
      },
      {
        path: "NonMaintenanceHistory",
        element: docLazyFn(<NonMaintenanceHistory />),
      },
      {
        path: "MonthlyWorker",
        element: docLazyFn(<MonthlyWorker />),
      },
      {
        path: "VendorClock",
        element: docLazyFn(<VendorClock />),
      },                                              
      {
        path: "MajorProject",
        element: docLazyFn(<MajorProject />),
      },
      {
        path: "MajorProjectEdit",
        element: docLazyFn(<MajorProjectEdit />),
      }, {
        path: "MaintenaceReport",
        element: docLazyFn(<MaintenaceReport />),
      },
      {
        path: "MonthlyWorkerPayment",
        element: docLazyFn(<MonthlyWorkerPayment />),
      },
      {
        path: "MaterialList",
        element: docLazyFn(<MaterialList />),
      },
    ],
  },
  // 不带沙盒
  {
    path: "/JobRequests/Maintenance/NewOrder",
    element: docLazyFn(<NewOrder />),
  },
  {
    path: "/JobRequests/Maintenance/Details",
    element: docLazyFn(<Details />),
  },
  {
    path: "/JobRequests/NonMaintenanceRequest/Details",
    element: docLazyFn(<NonMaintenanceDetails />),
  },
  {
    path: "/JobRequests/NonMaintenanceRequest/Add",
    element: docLazyFn(<AddNonMaintenanceRequest />),
  },
  {
    path: "/JobRequests/NonMaintenanceHistory/Detail",
    element: docLazyFn(<NonMaintenancHistoryeDetails />),
  },
  {
    path: "/JobRequests/VendorClock/Add",
    element: docLazyFn(<VendorClockAdd />),
  },
  {
    path: "/JobRequests/VendorClock/Map",
    element: docLazyFn(<Map />),
  },
    {
    path: "/JobRequests/Maintenance/PUTTable",
    element: docLazyFn(<PUTTable />),
  },
  {
    path: "/JobRequests/MaintenanceHistory/PUTTableHistory",
    element: docLazyFn(<PUTTableHistory />),
  },
];

export default jobRequests;
